export enum InvoiceDeliveryMethodIntegerEnum {
  letter = 0,
  mail = 1,
  file = 2,
  print = 3,
  home = 4,
  card = 5,
  member = 6,
  sms = 7, // Sms används inte än
  autogiro = 8,
  stripe = 9,
  kivra = 10,
  electronicInvoice = 11,
}
